import { defaultQueryClient } from '~/utils/ShippoQueryClientProvider';
import { FeatureFlags, decideFeatureFlag } from '~/utils/featureflags';

import { ORDERS_COUNT_QUERY_KEY } from '../constants/ordersCount.const';
import { countSelector } from '../selectors/ordersCount.selector';

export const refetchOrdersCountIfNeeded = () => {
  const ordersV2TableFlag = decideFeatureFlag(FeatureFlags.ORDERS_TABLE_API_V2_UI);

  const ordersCount = countSelector(
    defaultQueryClient.getQueryData<{ count: number }>([
      ORDERS_COUNT_QUERY_KEY,
      ordersV2TableFlag?.enabled ?? false,
    ]) || { count: 0 },
  );
  if (ordersCount > 0) return;

  defaultQueryClient.refetchQueries({ queryKey: [ORDERS_COUNT_QUERY_KEY] });
};
